import React from "react";
import ReactDOM from "react-dom";
import { AppContainer } from "react-hot-loader";
import { initialize as initializeAnalytics } from "analytics";
import { Modal } from "@cxagroup/casper";
import { isExist } from "cxa-utils";
import configureStore from "./store";
import Main from "./components/Main";
import { setCurrentUser, getUserSession } from "./actions/loginActions";
import { initialLocal as initialIntlLocale, addSupportLocal } from "./i18n/ReduxIntl";
import "react-select/dist/react-select.min.css";
import "./scss/all.scss";

initializeAnalytics();

window.CXAApollo = {
  ...(window.CXAApollo || {}),
  ...CXAApollo,
};

// TODO into webpack configure file
const dynamicImports = [
  import(/**
   * @see {@link https://momentjs.com/docs/#/use-it/browserify/}
   * @see {@link https://github.com/moment/moment/issues/2979#issuecomment-405657654}
   */
  "moment/min/locales.min"),
];
const store = configureStore(/* can pass initial state */);
const { dispatch } = store;

/**
 * Render application
 * @param {Component?} [App=Main]
 */
function startApp(App = Main) {
  const el = document.getElementById("root");

  ReactDOM.render(
    <AppContainer warnings={false}>
      <App store={store} />
    </AppContainer>,
    el,
    () => Modal.setAppElement(el)
  );
}

/**
 * TODO
 * these are not Redux actions (getUserSession, getToken)
 * - should move it to somewhere
 * - or use browser-storage, cookie as Redux middleware
 * @param  {string?} [user=getUserSession()]
 * @return {Promise}
 */
const setUser = ({ user = getUserSession() } = {}) => {
  if (isExist(user)) {
    const userInfo = JSON.parse(user);

    isExist(userInfo) && dispatch(setCurrentUser(userInfo));
  }

  return Promise.resolve();
};

Promise.all(dynamicImports)
  .then(() => setUser())
  .then(() => addSupportLocal())
  .then(() => initialIntlLocale(startApp));

if (module.hot) {
  module.hot.accept("./components/Main", () => {
    // If you use Webpack 2 in ES modules mode, you can
    // use <App /> here rather than require() a <NextApp />.
    const NextMain = require("./components/Main").default;

    startApp(NextMain);
  });
}

export { store };



// WEBPACK FOOTER //
// ./App.jsx